import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    authenticateGHTK(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    getListGHTK(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    deleteGHTK(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    createGHTKOrder(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    createOrderThirdParty(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    getShippingFee(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    getListOrder(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    printLabel(path: string, params: any): Promise<any> {
        return super.getPromisePDF(path, params)
    }
    cancelOrderGHTK(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    changeStatus(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
})()